import type { Campaign, CampaignItem, CampaignOrigin, Disparo } from '../types';

/** Pills de origem alinhadas ao Figma (derivado de `Campaign.origem`). */
export function campaignOriginLabels(origem: CampaignOrigin | undefined): string[] {
  if (!origem) return [];
  const map: Record<CampaignOrigin, string[]> = {
    lost_leads: ['perdidos'],
    partners: ['parceiros'],
    imported_leads: ['csv'],
    mixed: ['perdidos', 'parceiros', 'csv'],
  };
  return map[origem] ?? [];
}

/**
 * Progresso de envio dentro do pipeline ativo (pendente + disparado), igual à fração do footer do disparo.
 * Retorna 0–100.
 */
export function campaignDispatchProgressPercent(items: CampaignItem[]): number {
  const pend = items.filter((i) => i.pipelineStage === 'pendente').length;
  const disp = items.filter((i) => i.pipelineStage === 'disparado').length;
  const denom = pend + disp;
  if (denom === 0) return 0;
  return Math.round((100 * disp) / denom);
}

export function formatDisparoSchedule(d: Disparo | undefined): string {
  if (!d) return '—';
  const a = (d.horaInicio || '').trim();
  const b = (d.horaFim || '').trim();
  if (!a && !b) return '—';
  return `${a || '—'} - ${b || '—'}`;
}

export function campaignTotalLeadCount(camp: Campaign | undefined, fallbackFromItems: number): number {
  if (camp?.campaignItemCount != null && Number.isFinite(camp.campaignItemCount)) {
    return camp.campaignItemCount;
  }
  return fallbackFromItems;
}
